<div class="portfolio-assumptions">
  <klt-portfolio-compare
    (onSelect)="onSelectScenarios($event)"
    (buttonClick)="openDialog()"
  ></klt-portfolio-compare>
  <klt-portfolio-table [updatedData]="tableData"></klt-portfolio-table>
</div>
